import { Col, Row, Tag } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import styled from 'styled-components';
import { BidChance, bidChanceStatusKorean } from '../../modules/bid-chances';
import { styledTable } from '../styled/mixin';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface BidChanceListComponentProps {
  bidChances: BidChance[];
  moveToBidChanceDetailPage: (bidChanceId: number) => void;
}
function BidChanceListComponent({
  bidChances,
  moveToBidChanceDetailPage,
}: BidChanceListComponentProps) {
  const columns: ColumnsType<BidChance> = [
    {
      title: '공사명',
      dataIndex: ['bidder', 'bidPackage', 'name'],
      render: (text: any, record: any) => (
        <>
          <Tag>{record.bidder.bidPackage.isBudgeting ? '견적' : '입찰'}</Tag>
          <span
            className="clickable-table-item"
            onClick={() => moveToBidChanceDetailPage(record.id)}
          >
            {record.bidder.bidPackage.project.name} ({text})
          </span>
        </>
      ),
    },
    {
      title: '마감일',
      dataIndex: ['bidder', 'bidPackage', 'bidDueDateTime'],
      render: (text: any, record: any) =>
        moment(text).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: '클라이언트',
      dataIndex: ['bidder', 'bidPackage', 'project', 'enterprise', 'name'],
    },
    {
      title: '상태',
      dataIndex: 'status',
      render: (text: any, record: BidChance) =>
        bidChanceStatusKorean[record.status],
    },
  ];

  return (
    <StyledDiv>
      <Row>
        <Col>
          <h2>수주 관리</h2>
        </Col>
      </Row>

      {bidChances && (
        <Table<BidChance>
          rowKey="id"
          columns={columns}
          dataSource={bidChances}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
        />
      )}
    </StyledDiv>
  );
}
export default BidChanceListComponent;
